<template>
  <div>
    <div class="table-header mt-4">
      <div class="flex items-center">
        <div class="mr-2 filter">
          <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
        </div>
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>

          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
          />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
      </div>

      <div class="date-picker flex items-center justify-center">
        <p class="text-xs">Date Filter:</p>
        <el-date-picker
          v-model="filter.startDate"
          type="date"
          placeholder="Pick start date"
          class="mx-1"
        >
        </el-date-picker>
        <el-date-picker
          v-model="filter.endDate"
          type="date"
          placeholder="Pick end date"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="flex justify-end my-4">
      <router-link :to="{ name: 'PipelineSettings' }">
        <primary-button buttonText="Pipeline Settings" />
      </router-link>
    </div>

    <div class="responsive-table" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th><input type="checkbox" class="checkbox" /></th>
            <th>LEAD NAME</th>
            <th>PROFILE</th>
            <th>MULEEX ID</th>
            <th>BILLING ADD</th>
            <th>CONTACT PERSON</th>
            <th>EMAIL</th>
            <th>REGISTERED BY</th>
            <th>REG. CHANNEL</th>
            <th>STATUS</th>
            <th class="relative" tabindex="-1">
              <span class="cursor-pointer">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.7">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51"
                    />
                  </g></svg
              ></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="sale in sales" :key="sale.id" class="cursor-pointer">
            <!-- @click="viewContactProfile(contact.id)" -->
            <td><base-checkbox /></td>
            <td>{{ sale.name }}</td>
            <td>On-Demand</td>
            <td>{{ sale.code }}</td>
            <td>{{ sale.address ? sale.address : sale.location }}</td>
            <td>
              {{ sale.contactPerson ? sale.contactPerson : sale.name }}
            </td>
            <td>{{ sale.email }}</td>
            <td>MuleEx</td>
            <td>MuleEx</td>

            <td></td>
            <td class="relative" tabindex="-1" @blur="selectedRowId = null">
              <span
                @click="
                  selectedRowId
                    ? (selectedRowId = null)
                    : (selectedRowId = sale.id)
                "
                ><vertical-ellipsis
              /></span>
              <!-- <action-popup width="w-48" v-if="selectedRowId == sale.id">
                <div>
                  <p
                    class="py-1"
                    @click="
                      (selectedSale = sale),
                        (isBlacklistContactModal = true)
                    "
                  >
                    Blacklist this Contact
                  </p>
                  <p
                    class="py-1"
                    @click="
                      (selectedSale = sale), (isLoyaltyGroupModal = true)
                    "
                  >
                    Add to Loyalty Scheme
                  </p>
                  <p class="py-1">
                    Messaging
                  </p>
                  <p class="py-1">
                    Schedule a Meeting
                  </p>
                </div>
              </action-popup> -->
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!sales.length">
        <empty-table-icon />
        <p class="text-center text-sm">No sales yet!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sales",
  props: {},
  data() {
    return {
      sales: [],
      selectedRowId: null,
      selectedSale: {},
      filter: {
        startDate: "",
        endDate: "",
      },
    };
  },
  mounted() {
    this.getAllSales();
  },
  methods: {
    async getAllSales() {
      try {
        const response = await this.$_getAllSales();
        this.logResponse(response);
        this.sales = response.data.contacts;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
.table__search-input-wrapper {
  background: #ffffff;
  width: 20vw;
}
th,
td {
  padding: 0.75rem 0.25rem;
}
td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
}
th {
  font-size: 0.7rem;
  font-weight: 600;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
</style>
